import Summary from "./summary";
import Details from "./details";

export const caloriesBurnedSteps = [
	{
		id: "summary",
		title: "Summary",
		component: Summary
	},
	{
		id: "details",
		title: "Details ",
		component: Details
	}
];
